import { IExperiments } from '../../../../../../../../../../../types/reducers/experiments';
import { servicesCardsTextsExperimentName, TExperiments } from '../../../../../../../../../../../constants/experiments';
import { IGetTexts } from './getServiceText';

export const standardServiceControlGroup: IGetTexts = {
  title: 'Стандарт',
  subtitle: 'До х2 звонков',
  description: ['Отличный старт', 'Заметнее в поиске', 'Выше публикаций'],
};

export const standardServiceBGroup: IGetTexts = {
  title: 'Стандарт',
  subtitle: 'До х2 просмотров',
  description: ['Отличный старт', 'Заметнее в поиске', 'Выше публикаций'],
};

export const standardServiceCGroup: IGetTexts = {
  title: 'Стандарт',
  subtitle: 'До х2 показов',
  description: ['Отличный старт', 'Заметнее в поиске', 'Выше публикаций'],
};

export const getStandardTexts = (experiments: IExperiments, allExperiments: TExperiments): IGetTexts => {
  if (experiments[servicesCardsTextsExperimentName]) {
    const groups = allExperiments[servicesCardsTextsExperimentName];

    switch (experiments[servicesCardsTextsExperimentName]) {
      case groups?.default: {
        return standardServiceControlGroup;
      }
      case groups?.shows: {
        return standardServiceCGroup;
      }
      case groups?.views: {
        return standardServiceBGroup;
      }
    }
  }

  return standardServiceControlGroup;
};
